import { Button } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { CancelIcon, LoadingIcon, SaveIcon } from '@/shared/icons/Icons';

type ModalFooterProps = {
  disableSubmit?: boolean;
  isSubmitting?: boolean;
  labels?: {
    cancel?: string;
    submit?: string;
  };
  onCancel?: () => void;
  onSubmit?: () => void;
  submitButtonType?: 'button' | 'submit';
};

export const ModalFooterButtons: React.FC<ModalFooterProps> = ({
  disableSubmit,
  isSubmitting,
  labels,
  onCancel,
  onSubmit,
  submitButtonType = 'submit',
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        disabled={isSubmitting || disableSubmit}
        startDecorator={isSubmitting ? <LoadingIcon /> : <SaveIcon />}
        type={submitButtonType}
        onClick={onSubmit}
      >
        {labels?.submit || t('save')}
      </Button>
      <Button startDecorator={<CancelIcon />} color="neutral" variant="outlined" onClick={onCancel}>
        {labels?.cancel || t('cancel')}
      </Button>
    </>
  );
};

const ModalFooter: React.FC<ModalFooterProps> = (props) => (
  <div className="mt-6 flex flex-row-reverse gap-4">
    <ModalFooterButtons {...props} />
  </div>
);

export default ModalFooter;
